import { SearchResultSectionType } from './distribute.types';

export const priorityKeys = [
	SearchResultSectionType.recentSearches,
	SearchResultSectionType.recentVisited,
	SearchResultSectionType.popular,
];
